(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var options = {
    fullScreen: { enable: false },
    fpsLimit: 60,
    detectRetina: true,
    background: {
      color: { value: 'transparent' },
    },
    interactivity: {
      events: {
        onClick: { enable: false },
        onHover: { enable: false },
        resize: true,
      },
    },
    particles: {
      number: {
        value: 144,
        density: { enable: true, width: 800, height: 800 },
      },
      color: { value: ['#DFBD91', '#DFBD91', '#DFBD91', '#D7D9DC'] },
      shape: { type: 'circle' },
      size: { value: { min: 0.3, max: 1.35 } },
      opacity: {
        value: { min: 0.1, max: 1 },
        animation: {
          enable: true,
          speed: 1.6,
          sync: false,
        },
      },
      shadow: {
        enable: true,
        color: '#DFBD91',
        blur: 6,
      },
      move: {
        enable: !prefersReducedMotion,
        speed: { min: 0.1, max: 0.6 },
        direction: 'none',
        random: true,
        straight: false,
        outModes: { default: 'out' },
      },
      collisions: { enable: false },
      links: { enable: false },
    },
    twinkle: {
      particles: {
        enable: true,
        frequency: 0.1,
        opacity: 1,
        color: { value: '#DFBD91' },
      },
    },
    responsive: [],
  };

  function init() {
    var containers = document.querySelectorAll('.sparkles-background');
    if (!containers.length || !window.tsParticles || !window.loadSlim) return;

    window.loadSlim(window.tsParticles).then(function () {
      containers.forEach(function (el) {
        if (!el.id) return;
        var pageOptions = JSON.parse(JSON.stringify(options));
        if (el.dataset.sparkleColors) {
          pageOptions.particles.color.value = el.dataset.sparkleColors.split(',');
        }
        if (el.dataset.sparkleShadow) {
          pageOptions.particles.shadow.color = el.dataset.sparkleShadow;
        }
        window.tsParticles.load({ id: el.id, options: pageOptions });
      });
    });
  }

  if (!document.querySelector('.sparkles-background')) return;

  if (window.tsParticles && window.loadSlim) {
    init();
    return;
  }

  var attempts = 0;
  var poll = setInterval(function () {
    attempts += 1;
    if (window.tsParticles && window.loadSlim) {
      clearInterval(poll);
      init();
    } else if (attempts > 50) {
      clearInterval(poll);
    }
  }, 100);
})();
